module.exports = __webpack_public_path__ + "img/block-blue.f365f66c.webp";